import styled from 'styled-components/macro';

import { DefaultText, OrderActionAdditionalInfoText } from '../../../common/fontElements';
import { baseText, formInputTextForFilledBack } from '../../../common/colorConstants';
import { FullColoredButton } from '../../../common/buttonsComponents';

export const RefundOrderButton = styled(FullColoredButton)``;

export const Divider = styled.div`
  width: calc(100% + 16px);
  height: 1px;
  margin-left: -8px;
  margin-right: -8px;

  background-color: #d8e8ef;
`;

export const CancelStep = styled.div`
  padding: 10px 0;
`;

export const StepTitle = styled(OrderActionAdditionalInfoText)`
  padding: 10px 0;
  font-size: 12px;
`;

export const Subtext = styled.span`
  opacity: 0.9;
  color: #7f7f7f;
`;

// Step 1

export const ItemRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
`;

export const Checkbox = styled.input`
  margin: 5px !important;
`;

export const RowContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;

  flex: 1 1;
`;

export const ItemDetail = styled(DefaultText)`
  color: ${baseText};
  opacity: ${({ active }) => (active ? '1' : '0.8')};
`;

// Step 2

export const RefundCommentTextarea = styled.textarea`
  flex: 2 1;

  min-height: 120px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.3;
  padding: 5px;

  color: ${formInputTextForFilledBack};
  border: 1px solid #4697c3;
  background-color: #f8fafc;
`;

export const FlexPlaceholder = styled.div`
  flex: 1 10;
`;

export const OrderSummaryBox = styled.div`
  flex: 1 1;
  flex-direction: column;
`;

export const OrderSummaryHeader = styled.div`
  font-size: 11px;
  font-family: Lato-Bold, sans-serif;

  color: #1c6774;

  padding: 8px;
`;

export const OrderSummaryInfo = styled.div`
  font-size: 9px;

  color: #1c6774;
  background-color: #f8fafc;

  border-radius: 3px;
  padding: 8px;
`;

export const OrderSubtotalInfo = styled.div`
  font-size: 9px;
  font-family: Lato-Bold, sans-serif;
`;
